// #region Local
export const WEBSERVER = "/webserver.json";
export const WEBSERVER_PROD = `/device/webserver.prod.json`;
// #endregion

export const DEVICE_HUB = "hub/device";
export const DEVICE_HUB_NEGOTIATE = "hub/device/negotiate";

const Root = {
  API: "api",
};

// const Version = {
//   v1: 'v1',
// };

const Services = {
  DEVICE: "device",
  WARMING_UP: "warming-up",
  SAMBA_USER: "sambauser",
  UPDATE: "update",
  CONCENTRATOR: "concentrator",
  SOFTWARE: "software",
  ADV_SETUPS: "advsetups",
  VOLUME_SENSOR: "volume-sensor",
  WIFI: "wifi",
  SYSTEM: "system",
  RETURN_VALVE_PRESSURE: "ReturnValvePressure",
  DELAY_PROFILE: "delay-profile",
};

/**
 * @FIXME Please keep the consistency on defining the constant
 */
export const RestAPI = {
  MAIN_APP: "",
  UI_ERROR_REPORT: [Root.API, Services.DEVICE, "ui-error-report"].join("/"),
  REBOOT_SERVICE: [Root.API, Services.DEVICE, "reboot"].join("/"),
  CYCLE_PARAM_DEVICE: [Root.API, Services.DEVICE, "cycle-param"].join("/"),
  START_SEQUENCE_DESIGNER_DEVICE: [
    Root.API,
    Services.DEVICE,
    "custom-operations",
    "start",
  ].join("/"),
  PAUSE_SEQUENCE_DESIGNER_DEVICE: [
    Root.API,
    Services.DEVICE,
    "custom-operations",
    "pause",
  ].join("/"),
  RESUME_SEQUENCE_DESIGNER_DEVICE: [
    Root.API,
    Services.DEVICE,
    "custom-operations",
    "resume",
  ].join("/"),
  STOP_SEQUENCE_DESIGNER_DEVICE: [
    Root.API,
    Services.DEVICE,
    "custom-operations",
    "stop",
  ].join("/"),
  SAVE_SEQUENCE_DESIGNER_DEVICE: [
    Root.API,
    Services.DEVICE,
    "custom-operations",
    "savesequence",
  ].join("/"),
  WARMING_UP_STATUS: [Root.API, Services.WARMING_UP, "status"].join("/"),
  WARMING_UP_CONFIG: [Root.API, Services.WARMING_UP, "config"].join("/"),
  WARMING_UP_VIDEO: [Root.API, Services.WARMING_UP, "video"].join("/"),
  WARMING_UP_VIDEO_STOP: [Root.API, Services.WARMING_UP, "video", "stop"].join(
    "/"
  ),
  SAMBA_USER: [Root.API, Services.SAMBA_USER].join("/"),
  MANUAL_UPDATE_SW: [
    Root.API,
    Services.UPDATE,
    "manual-update",
    "software",
  ].join("/"),
  CANCEL_UPDATE_SW: [Root.API, Services.UPDATE, "cancel-update"].join("/"),
  INSTALL_UPDATE_SW: [
    Root.API,
    Services.UPDATE,
    "install-update",
    "software",
  ].join("/"),
  PROGRESS_UPDATE_SW: [Root.API, Services.UPDATE, "get-progress"].join("/"),
  STATUS_UPDATE_SW: [Root.API, Services.UPDATE, "get-update-status"].join("/"),
  CHECK_VERSION_UPDATE_SW: [Root.API, Services.UPDATE, "check-version"].join(
    "/"
  ),
  PAUSE_CONCENTRATOR: [Root.API, Services.CONCENTRATOR, "pause"].join("/"),
  RESUME_CONCENTRATOR: [Root.API, Services.CONCENTRATOR, "resume"].join("/"),
  STOP_CONCENTRATOR: [Root.API, Services.CONCENTRATOR, "stop"].join("/"),
  REFILL_CONCENTRATOR: [
    Root.API,
    Services.CONCENTRATOR,
    "diafiltration",
    "refill-buffer",
  ].join("/"),
  CANCEL_REFILL_CONCENTRATOR: [
    Root.API,
    Services.CONCENTRATOR,
    "diafiltration",
    "cancel-refill-buffer",
  ].join("/"),
  NEW_START_CONCENTRATOR: [
    Root.API,
    Services.CONCENTRATOR,
    "new-auto",
    "start",
  ].join("/"),
  STOP_MIXING_CONCENTRATOR: [
    Root.API,
    Services.CONCENTRATOR,
    "mixing",
    "stop",
  ].join("/"),
  RESTART_SERVICE: [Root.API, Services.SOFTWARE, "restartService"].join("/"),
  STATUS: [Root.API, "status"].join("/"),
  CONFIGURATION: [Root.API, "configuration"].join("/"),
  ADV_SETUP: [Root.API, Services.ADV_SETUPS].join("/"),
  DEFAULT_ADV_SETUP: [Root.API, Services.ADV_SETUPS, "default"].join("/"),
  ROW_VALUE_VOLUME_SENSOR: [Root.API, Services.VOLUME_SENSOR, "row-value"].join(
    "/"
  ),
  IS_AVAILABLE_WIFI: [Root.API, Services.WIFI, "IsWifiAvailable"].join("/"),
  DISPLAY_SETTING_SYSTEM: [Root.API, Services.SYSTEM, "display-settings"].join(
    "/"
  ),
  GET_DETAIL_SEQUENCE: [
    Root.API,
    Services.DEVICE,
    "custom-operations",
    "getdetailsequence",
  ].join("/"),
  OPERATIONS_MANUAL_PROFILES: [
    Root.API,
    Services.DEVICE,
    "custom-operations",
    "manual-profiles",
  ].join("/"),
  SET_FAVORITE_SEQUENCE: [
    Root.API,
    Services.DEVICE,
    "custom-operations",
    "manual-profile",
    "favorite",
  ].join("/"),
  SET_SYS_SETTING_SYSTEM: [Root.API, Services.SYSTEM, "set-systemsetting"].join(
    "/"
  ),
  GET_AUTO_TIME_ZONE_SYSTEM: [
    Root.API,
    Services.SYSTEM,
    "get-autotimezone",
  ].join("/"),
  GET_DATE_TIME_LOCAL_SYSTEM: [
    Root.API,
    Services.SYSTEM,
    "get-datetime-fromlocal",
  ].join("/"),
  GET_DATE_TIME_SERVER_SYSTEM: [
    Root.API,
    Services.SYSTEM,
    "get-datetime-fromserver",
  ].join("/"),
  GET_TIME_ZONE_AREAS_SYSTEM: [
    Root.API,
    Services.SYSTEM,
    "getlist-timezonearea",
  ].join("/"),
  GET_TIME_ZONE_REGIONS_SYSTEM: [
    Root.API,
    Services.SYSTEM,
    "getlist-timezoneregion",
  ].join("/"),
  DEVICE_PROPS_SYSTEM: [Root.API, Services.SYSTEM, "device-properties"].join(
    "/"
  ),
  HARDWARE_PROPS_SYSTEM: [
    Root.API,
    Services.SYSTEM,
    "hardawre-properties",
  ].join("/"),
  INFO_SYSTEM: [Root.API, Services.SYSTEM, "info"].join("/"),
  FACTORY_DEFAULT_RETURN_VALVE_PRESSURE: [
    Root.API,
    Services.RETURN_VALVE_PRESSURE,
    "factory-default",
  ].join("/"),
  DEFAULT_RETURN_VALVE_PRESSURE: [
    Root.API,
    Services.RETURN_VALVE_PRESSURE,
    "default",
  ].join("/"),
  UPDATE_RETURN_VALVE_PRESSURE: [
    Root.API,
    Services.RETURN_VALVE_PRESSURE,
    "update",
  ].join("/"),
  SET_DELAY_PROFILE: [Root.API, Services.DELAY_PROFILE, "add"].join("/"),
  DELAY_PROFILE: [Root.API, Services.DELAY_PROFILE].join("/"),
  CANCEL_SENSOR_CHECK: [
    Root.API,
    Services.CONCENTRATOR,
    "validation",
    "cancel-sensor-stabilisation-check",
  ].join("/"),
};
